import { object, string } from "yup";
import { ERRORS } from "../constants";

export const addAddressValidation = object().shape({
    firstName: string().required(ERRORS.required)
})